<template>
	<div class="job-details">

		<div>
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Directions</h4>
				</div>
				<div class="subsection__content">
					<editable-html-editor 
						:editable="canEditField('jobDirections')"
						label=""
						label-large
						:value="job.directions"
						prop-to-update="directions"
                        :maxLength="10000"
						:dispatch-on-save="saveUpdateProp"/>
				</div>
			</div>

			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Job Specifications</h4>
				</div>
				<div class="subsection__content">
					<editable-html-editor 
						:editable="canEditField('jobSpecifications')"
						label=""
						label-large
						:value="job.specifications"
						prop-to-update="specifications"
						:dispatch-on-save="saveUpdateProp"/>
				</div>
			</div>

			<delivery-options
				:editable="canEditField('jobDeliveryOptions')"
				:type="job.type"
				:department="job.department"
				dataSet="job"/>
			
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Delivery Instructions</h4>
					<ul v-if="job.type === 'Multimedia'">
						<li>Frame Rate (i.e. 24fps)</li>
						<li>Codec/File type (i.e. MP4)</li>
						<li>Duration in seconds (i.e. 30sec)</li>
						<li>Size in pixels Width x Height (i.e. 1920x1080)</li>
						<li>File size limit (i.e. under 10MB)</li>
					</ul>
				</div>
				<div class="subsection__content">
					<editable-html-editor
						:editable="canEditField('jobDeliveryInstructions')"
						:value="job.delivery_instructions"
						prop-to-update="delivery_instructions"
						:dispatch-on-save="saveUpdateProp"/>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	import { VUEX_JOB_UPDATE_PROP } from '@/store/constants/jobs'

	import EditableHTMLEditor from '@/components/ui/_global/editable/HTMLEditor.vue'
	import JobDetailsDeliveryOptions from '@/components/ui/Jobs/Job_Details_Delivery_Options.vue'

	export default {
		name: 'job-details',
		
		components: {
			'editable-html-editor': EditableHTMLEditor,
			'delivery-options': JobDetailsDeliveryOptions
		},

		computed: {
			...mapState({
				job: state => state.jobs.job
			}),

			...mapGetters({
				canEditField: 'canEditField'
			}),
		},
		methods: {
			...mapActions({
				saveUpdateProp: VUEX_JOB_UPDATE_PROP
			}),
		}
	}
</script>